import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const errorCodes = {
  404: 'User not found',
  23505: 'Email address used notification',
};

const useErrorHandler = () => {
  const { t } = useTranslation();

  const errorHandler = (error) => {
    let message = error.message;
    const errorCode = error?.response?.data?.errorCode;
    if (errorCode) {
      message = errorCodes[errorCode] || 'Something went wrong';
    }
    toast.error(t(message));
    throw error;
  };

  return errorHandler;
};

export default useErrorHandler;
